import PropTypes from 'prop-types';
import React from 'react';
import { FeedArticlesList, ForecasterProfile, Spinner } from '@surfline/quiver-react';
import ForecastConditions from '../ForecastConditions';
import FeedForecastHeader from '../FeedForecastHeader';
import articlePropType from '../../propTypes/article';
import subregionPropType from '../../propTypes/subregion';
import unitsPropType from '../../propTypes/units';
import forecastConditionPropType from '../../propTypes/forecastCondition';
import forecastSummaryPropType from '../../propTypes/forecastSummary';
import subregionForecastPath from '../../utils/urls/subregionForecastPath';
import trackForecastOutlookLink from '../../utils/trackForecastOutlookLink';

const FeedForecast = ({
  articles,
  doFetchForecastArticles,
  subregionId,
  subregionName,
  summary,
  breadcrumb,
  conditions,
  units,
  utcOffset,
  subregions,
  onSetHomeForecast,
  doTrackFeed,
  isLoggedIn,
  loading,
}) => {
  const forecastLink = subregionForecastPath(subregionId, subregionName);
  return (
    <div className="sl-feed-forecast">
      {!loading ? (
        <div>
          <FeedForecastHeader
            onSetHomeForecast={onSetHomeForecast}
            subregionName={subregionName}
            subregions={subregions}
            isLoggedIn={isLoggedIn}
            doTrackFeed={doTrackFeed}
            mapUrl={breadcrumb[breadcrumb.length - 1].href}
          />
          {articles.regional.length ? (
            <FeedArticlesList
              articles={articles}
              doFetchForecastArticles={doFetchForecastArticles}
              subregionId={subregionId}
              subregionName={subregionName}
              doTrackFeed={doTrackFeed}
              location="homepage"
            />
          ) : null}
          <div className="sl-feed-forecast__heading__container">
            <h5 className="sl-feed-forecast__heading">{subregionName} Forecast</h5>
            <a
              className="sl-feed-forecast__heading__container__link"
              href={forecastLink}
              onClick={() =>
                trackForecastOutlookLink(doTrackFeed, {
                  linkName: 'View 17-day forecast',
                  linkUrl: forecastLink,
                })
              }
            >
              View 17-day forecast
            </a>
          </div>
          <div className="sl-feed-forecast__observation">
            {summary.forecaster && summary.forecastStatus.status === 'active' ? (
              <ForecasterProfile
                forecasterName={summary.forecaster.name}
                forecasterTitle={summary.forecaster.title}
                url={summary.forecaster.iconUrl}
                small
              />
            ) : null}
          </div>
          <div className="sl-feed-forecast__conditions">
            {conditions.slice(0, 2).map(condition => (
              <ForecastConditions
                forecastLink={forecastLink}
                key={condition.timestamp}
                timestamp={condition.timestamp}
                am={condition.am}
                pm={condition.pm}
                units={units}
                utcOffset={utcOffset}
                doTrackFeed={doTrackFeed}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="sl-feed-forecast--loading">
          <Spinner />
        </div>
      )}
    </div>
  );
};

FeedForecast.propTypes = {
  articles: PropTypes.shape({
    pageCount: PropTypes.number,
    regional: PropTypes.arrayOf(articlePropType),
  }),
  doFetchForecastArticles: PropTypes.func.isRequired,
  subregionId: PropTypes.string.isRequired,
  subregionName: PropTypes.string.isRequired,
  summary: forecastSummaryPropType.isRequired,
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  conditions: PropTypes.arrayOf(forecastConditionPropType).isRequired,
  units: unitsPropType.isRequired,
  utcOffset: PropTypes.number.isRequired,
  onSetHomeForecast: PropTypes.func.isRequired,
  subregions: PropTypes.arrayOf(subregionPropType).isRequired,
  doTrackFeed: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
};

FeedForecast.defaultProps = {
  articles: [],
  loading: false,
};

export default FeedForecast;
